import { Box, Text } from '@chakra-ui/react';
import { Accordion, Table } from '@morressier/alembic';
import { recommendationBadges } from 'src/components/Review/Badges';
import AccordionTitle from './AccordionTitle';
import { ReviewerInfo } from '@publishing-engine/domain/models';
import dateFormat from 'dateformat';
const HeadersTitle = ['Reviewer', 'Recommendation', 'Decision Submitted on'];
interface TableColumn {
  key: string;
  label: string;
  size: string | number;
  render?: (review: ReviewerInfo) => React.ReactNode;
}
const REVIEW_TABLE_COLUMNS = (): TableColumn[] => [
  {
    key: 'reviewer',
    label: 'Reviewer',
    size: 1,
    render: review => (
      <Box maxWidth={'full'} paddingX={2}>
        <Text
          textStyle="headingItem"
          isTruncated
          textDecoration="none"
          _hover={{
            textDecoration: 'underline',
            textDecorationColor: 'actionPrimaryFill'
          }}
          color="actionPrimaryFill"
        >
          {review.firstName} {review.lastName}
        </Text>
      </Box>
    )
  },

  {
    key: 'recommendation',
    label: 'Recommendation',
    size: 1,
    render: review => <Box>{recommendationBadges[review.recommendation]}</Box>
  },
  {
    key: 'decisionsubmittedon',
    label: 'Decision Submitted on',
    size: 1,
    render: review => (
      <Box>{dateFormat(review.dateSubmitted, 'mmm d, yyyy')}</Box>
    )
  }
];
type PeerReviewLogProps = {
  PeerReviewInfo: ReviewerInfo[];
};
const PeerReviewLog: React.FC<PeerReviewLogProps> = ({ PeerReviewInfo }) => {
  const tableColumns = REVIEW_TABLE_COLUMNS();
  return (
    <>
      <Accordion
        data-testId=" PeerReview-Log"
        chakraAccordionProps={{
          allowMultiple: true,
          defaultIndex: [0],
          style: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%'
          }
        }}
        items={[`Peer Review (${PeerReviewInfo.length})`].map(item => {
          return {
            title: <AccordionTitle title={item} />,
            content: (
              <Table>
                <Table.HeaderRow>
                  {HeadersTitle.map(title => {
                    return (
                      <>
                        <Table.HeaderCell flex={'1'} textAlign="left">
                          <Text>{title}</Text>
                        </Table.HeaderCell>
                      </>
                    );
                  })}
                </Table.HeaderRow>
                <Table.Body>
                  {PeerReviewInfo.map(review => {
                    return (
                      <>
                        <Table.Row>
                          {tableColumns.map(column => (
                            <Table.RowCell
                              key={column.key}
                              flex={column.size}
                              textAlign="left"
                              height={'full'}
                            >
                              {column.render ? column.render(review) : null}
                            </Table.RowCell>
                          ))}
                        </Table.Row>
                      </>
                    );
                  })}
                </Table.Body>
              </Table>
            )
          };
        })}
      />
    </>
  );
};

export default PeerReviewLog;
